module.exports = __webpack_public_path__ + "img/new_index_industry_icon1.4770f69b.png";